import { LogoutOptions } from '@auth0/auth0-react';
import { snapshot } from 'valtio';
import settingsService from '../services';
import {
  closeRemoveMemberModal,
  handleSelfDeletion,
  isSelfDeletion,
} from '../store-actions/remove-member-store-actions';
import MembersStore from '../stores/members-store';
import RemoveMemberStore from '../stores/remove-member-store';
import { ActiveMember } from '../types/members-types';

export const removeActiveMember = async (
  activeMember: ActiveMember,
  logout: (options?: LogoutOptions) => void,
): Promise<void> => {
  RemoveMemberStore.isLoading = true;

  const deleteRelatedProm = activeMember.relatedIDs.map(rID =>
    settingsService.deleteMember.execute(rID, activeMember.email),
  );

  const deletedRelated = await Promise.all(deleteRelatedProm);
  const deletedPrimary = await settingsService.deleteMember.execute(
    activeMember.user_id,
    activeMember.email,
  );

  const deletedSuccessfully = deletedPrimary && !deletedRelated.includes(false);
  if (deletedSuccessfully) {
    const { activeMembers } = snapshot(MembersStore);
    MembersStore.activeMembers = activeMembers.filter(
      a => a.user_id !== activeMember.user_id,
    );
  }

  if (deletedSuccessfully && isSelfDeletion(activeMember.user_id)) {
    handleSelfDeletion(logout);
  }

  closeRemoveMemberModal();
  RemoveMemberStore.isLoading = false;
};
